import {
  HookCallbacks,
  HookSafeActionFn,
  useAction,
} from 'next-safe-action/hooks'

import { SafeActionError } from './safe-action.types'
import { showToast } from '../utils/toast'

// Structural copy of StandardSchemaV1 — avoids importing from next-safe-action's internal bundle.
// Must stay structurally identical to the interface in next-safe-action/dist/index.types-*.d.mts.
interface StandardSchemaV1<Input = unknown, Output = Input> {
  readonly '~standard': {
    readonly version: 1
    readonly vendor: string
    readonly validate: (
      value: unknown,
    ) => { value: Output; issues?: undefined } | { issues: ReadonlyArray<{ message: string }> } | Promise<{ value: Output; issues?: undefined } | { issues: ReadonlyArray<{ message: string }> }>
    readonly types?: { readonly input: Input; readonly output: Output } | undefined
  }
}

const useSafeAction = <SE, S extends StandardSchemaV1 | undefined, ShE, D>(
  safeActionFn: HookSafeActionFn<SE, S, ShE, D>,
  utils?: HookCallbacks<SE, S, ShE, D>,
) => {
  return useAction<SE, S, ShE, D>(safeActionFn, {
    onError: ({ error }) => {
      const serverError = error.serverError
      serverError && showToast((serverError as unknown as SafeActionError).description)
    },
    ...utils,
  })
}

export default useSafeAction
